import request from './request'

const zhCN = { msgRequest: request.zhCN }
const enUS = { msgRequest: request.enUS }
export default { zhCN, enUS }